export default __webpack_public_path__ + "static/broadcastImg2-509c3b0795f49981edee1d233338be7c.webp";